export default "__VITE_ASSET__CsuU7gbW__"